
















































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ListModel } from "@/shared/models/listModel";
import {
  RatePlanTilesModel,
  RatePlanTypeFilterEnum,
} from "@/shared/models/ratePlanModel";
import RatePlanForm from "./RatePlanForm.vue";
import { Notification } from "../store/modules/notifications";
import handleBrokenRuleAdapter from "@/shared/handleBrokenRuleAdapter";
import NoData from "@/components/misc/NoData.vue";

@Component({
  components: {
    RatePlanForm,
    NoData,
  },
})
export default class RatePlansTiles extends Vue {  
  ratePlans: RatePlanTilesModel[] = [];

  loading = true;
  deleting = false;

  mounted() {
    this.load();
  }

  get filterOptions() {
    return [
      {
        id: RatePlanTypeFilterEnum.All,
        name: "RatePlans.All",
      },
      {
        id: RatePlanTypeFilterEnum.Normal,
        name: "RatePlans.Normal",
      },
      {
        id: RatePlanTypeFilterEnum.ActiveOffers,
        name: "RatePlans.ActiveOffers",
      },
      {
        id: RatePlanTypeFilterEnum.AllOffers,
        name: "RatePlans.AllOffers",
      },
    ];
  }

  filters = {
    ratePlanType: RatePlanTypeFilterEnum.All,
  };

  @Watch("filters", { deep: true })
  filtersWatch() {
    this.load();
  }

  load() {
    this.loading = true;
    this.ratePlans = [];
    Vue.axios
      .get<ListModel<RatePlanTilesModel>>("RatePlans", {
        params: this.filters,
      })
      .then((res) => {
        this.ratePlans = [];
        if(
          this.filters.ratePlanType == RatePlanTypeFilterEnum.ActiveOffers || 
          this.filters.ratePlanType == RatePlanTypeFilterEnum.AllOffers
        ) {
          this.ratePlans = res.data.result;
        }
        else {
          for (const ratePlan of res.data.result.filter((x) => !x.isDerived)) {
            this.ratePlans.push(ratePlan);

            this.ratePlans.push(
              ...res.data.result.filter((x) => x.parentRatePlanId == ratePlan.id)
            );
          }
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  formOpen = false;
  formRatePlanId: number | null = null;
  formParentRatePlanId: number | null = null;
  addRatePlan() {
    this.formRatePlanId = null;
    this.formParentRatePlanId = null;
    this.formOpen = true;
  }

  editRatePlan(ratePlanId: number) {
    this.formRatePlanId = ratePlanId;
    this.formParentRatePlanId = null;
    this.formOpen = true;
  }

  createDerivedRatePlan(ratePlan: RatePlanTilesModel) {
    if (ratePlan.isSpecialOffer) return;
    this.formRatePlanId = null;
    this.formParentRatePlanId = ratePlan.id;
    this.formOpen = true;
  }

  deleteRatePlan(ratePlan: RatePlanTilesModel) {
    this.$store.dispatch("showNotification", {
      id: ratePlan.id,
      color: "warning",
      message: this.$t("RatePlan.DeleteConfirmation", {
        value: ratePlan?.name,
      }),
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deleteConfirmed(ratePlan.id, []);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }

  deleteConfirmed(id: number, overrides: string[]) {
    const handleCodes = ["RatePlan.DeleteConfirmation.LastOnUnitType", "RatePlan.DeleteValidation.OtaSync"];
    const adapter = handleBrokenRuleAdapter(this.axios, handleCodes);

    // prettier-ignore
    const formatBrokenRuleNames = (x: string[]) => x
      .map((h) => this.$t(h).toString())
      .map((th) => th.endsWith(".") ? th : th + ".")
      .join(" ");

    const isOverriding = overrides.length !== 0;

    this.deleting = true;
    Vue.axios
      .delete(`/RatePlans/${id}`, {
        data: { overrideRules: overrides },
        adapter: isOverriding ? undefined : adapter,
      })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("RatePlan.DeleteSuccess"),
          timeout: 5000,
        } as Notification);

        this.load();
      })
      .catch((x) => {
        if (x && x.isHandleBrokenRuleResult && !isOverriding) {
          this.$store.dispatch("showNotification", {
            color: "warning",
            message:
              // prettier-ignore
              `${formatBrokenRuleNames(x.handled)} ${this.$t("Do you wish to continue anyway?")}`,
            timeout: 30000,
            actions: [
              {
                text: this.$t("Yes"),
                fun: () => {
                  this.deleteConfirmed(id, x.handled);
                  return true;
                },
              },
              { text: this.$t("Cancel"), fun: () => true },
            ],
          } as Notification);
        } else {
          this.$store.dispatch("showNotification", {
            color: "error",
            message: `${formatBrokenRuleNames(x.unhandled)}`,
            timeout: 5000,
          } as Notification);
        }
      })
      .finally(() => {
        this.deleting = false;
      });
  }

  getIncludesText(ratePlan: RatePlanTilesModel) {
    const includes: string[] = [];
    if (ratePlan.includesBreakfast) {
      includes.push(this.$t("breakfast").toString());
    }
    if (ratePlan.includesLunch) {
      includes.push(this.$t("lunch").toString());
    }
    if (ratePlan.includesDinner) {
      includes.push(this.$t("dinner").toString());
    }

    if (includes.length > 0) {
      return this.$t("Includes") + " " + includes.join(", ");
    } else {
      return "";
    }
  }

  getStatusText(ratePlan: RatePlanTilesModel) {
    if (!ratePlan.isSpecialOffer) {
      return "";
    }

    return (
      this.$t("RatePlans.SpecialOrPackageOffer") +
      (ratePlan.isExpired ? ` - ${this.$t("RatePlans.Expired")}` : "") +
      (ratePlan.isDeactivated ? ` - ${this.$t("RatePlans.Deactivated")}` : "")
    );
  }
}
